import {get} from 'lodash';

export default (state = {}, {userId, clients, orders, candidates}: any) => {
  return {
    ...state,
    allClients: {
      ...get(state, 'allClients', {}),
      [userId]: {clients, orders, candidates},
    },
  };
};
